const ORDERS_URL = process.env.VUE_APP_API_URL.concat("/rest/V1/b2b-order/post");
import { request } from '../services/request'

 function mapLinesToProducts(line, currencyRatio) {
     return {
         product: {
            ...line.product,
            deliveryDate: line.deliveryDate
         },
         quantity: line.quantity,
         discount: line.discount,
         type: line.option,
         comment: line.comment,
         location: line.localization,
         basePrice: line.basePrice / currencyRatio
     }
 }
export default {
    namespaced: true,
    state: {
        offlineOrders: []
    },
    actions: {
        storeOrder(context, order) {
            const userData = context.rootState.auth.user;
            let orderData = {
                paymentOptions: order.payment,
                shippingOptions: order.shipping,
                shippingOptionsValue: order.shippingValue,
                currency: context.rootState.currency.currency,
                language: order.language,
                comment: order.comment,
                customer: order.customer,
                proposalTime: order.proposalTime,
                products: order.lines.map((product) => mapLinesToProducts(product, context.rootState.currency.ratio))
            }
            if (navigator.onLine) {
                let options = {
                    data: {
                        order: orderData,
                        user: userData,
                    },
                    url: ORDERS_URL
                };
                request('post', options,"createOrderService");
            } else {
                // Deep clone to avoid mutations
                context.commit('addOfflineOrder', {
                    ...order,
                    lines: [...order.lines]
                })
            }
        },
        launchOfflineOrders ({ commit, state, dispatch }) {
            state.offlineOrders.forEach(async order => {
                await dispatch('storeOrder', order)
                commit('removeOfflineOrder', order)
            })
        }
    },
    mutations: {
        addOfflineOrder(state, order) {
            state.offlineOrders.push(order)
        },
        removeOfflineOrder(state, order) {
            state.offlineOrders.splice(
                state.offlineOrders.indexOf(order),
            )
        }
    }
};
